import { drawing, geometry } from '@progress/kendo-drawing';
import { Element } from './Element.js';
import { sizeOptionsOrDefault } from './utils.js';
import { WIDTH, HEIGHT, X, Y } from '../constants.js';

class Image extends Element {
    constructor(options) {
        super(options);
        this._initImage();
    }
    redraw(options) {
        if (options) {
            if (options.source) {
                this.drawingElement.src(options.source);
            }
            if (this._diffNumericOptions(options, [WIDTH, HEIGHT, X, Y])) {
                this.drawingElement.rect(this._rect());
            }
            super.redraw(options);
        }
    }
    _initImage() {
        const options = this.options;
        const rect = this._rect();
        this.drawingElement = new drawing.Image(options.source, rect);
    }
    _rect() {
        const sizeOptions = sizeOptionsOrDefault(this.options);
        const origin = new geometry.Point(sizeOptions.x, sizeOptions.y);
        const size = new geometry.Size(sizeOptions.width, sizeOptions.height);
        return new geometry.Rect(origin, size);
    }
}

export { Image };
